/* ============================================================
   FGO PROMO BAR — cart updates and taps (27 Sep 2026, v4.68 track D)
   ------------------------------------------------------------
   Paired with sections/theme-announcement.liquid, which renders the
   right state for first paint (Liquid reads cart.total_price, the
   product's selling plans, the promo dates). This file only REFINES
   it after the page is interactive; if it fails to load, the bar
   stays on its Liquid state.

   Loaded defer, and only when smart states are on AND the page can
   need it (cart progress on, or a product-page state rendered).

   1. CART WRITES. window.fetch and XMLHttpRequest are wrapped to spot
      POSTs to /cart/(add|change|update|clear). When one settles, a
      single GET /cart.js runs (150ms trailing throttle, one request
      in flight) and the bar re-decides with the same order Liquid
      used: a promo or product-page bar holds; otherwise cart under /
      at-or-over the threshold, or the empty-cart default. The drawer
      being open or shut does not matter, the numbers come from the
      cart. Also refreshed on pageshow when the page came back from
      the back/forward cache.

   2. NO LAYOUT SHIFT. State changes only show/hide full-width
      containers (hidden -> shown is not a shift), and the "$X from"
      line is updated by REPLACING its nodes, never by editing text in
      place, so nothing that was on screen moves. The hairline is a
      background on the section wrapper. Measured 27 Sep: CLS 0 from
      the bar on load and across add / change / clear.

   3. ANNOUNCED POLITELY. The visible text is not a live region (it is
      replaced wholesale); a visually hidden aria-live="polite" span
      carries only the new cart line, and is emptied 5s later so a
      screen reader does not meet it twice when reading the bar.

   4. TAPS. Cart states click the header cart button, so the same
      code opens the theme's drawer on the sandbox and UpCart on
      production. The product-page state selects the Subscribe option
      the way a click would (input.click(): the buy box's own change
      handlers repaint the price), scrolls it clear of the sticky bar
      and header, pulses it (reduced motion: a static ring) and moves
      focus to it.

   Money: formatted with the shop's money format passed from Liquid
   (data-money), dropping ".00" on whole amounts the way Liquid's
   money_without_trailing_zeros does.
   ============================================================ */
(function () {
  'use strict';

  var a = document.getElementById('announcement');
  if (!a || !a.hasAttribute('data-fgo-ab') || a.__fgoAb) return;
  a.__fgoAb = true;

  var d = a.dataset;
  var wrap = a.parentNode;
  var thr = +d.thr || 0;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var live = a.querySelector('[data-fgo-ab-live]');
  var WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  var SEP = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_space_separator: [2, ' ', ','],
    amount_no_decimals_with_space_separator: [0, ' ', ','],
    amount_with_apostrophe_separator: [2, "'", '.']
  };
  function money(cents) {
    var fmt = d.money || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var sp = SEP[m ? m[1] : 'amount'] || SEP.amount;
    var parts = (Math.max(0, Math.round(cents)) / 100).toFixed(sp[0]).split('.');
    var v = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sp[1]);
    if (parts[1] && parts[1] !== '00') v += sp[2] + parts[1];
    return m ? fmt.replace(m[0], v) : fmt + v;
  }

  function el(s) { return a.querySelector('[data-s="' + s + '"]'); }
  function text(node) { var t = node && node.querySelector('.fgo-ab__t'); return t ? t.textContent : ''; }

  function set(s, pct) {
    if (!el(s)) return false;
    for (var k = a.children, i = 0; i < k.length; i++) {
      if (!k[i].hasAttribute('data-s')) continue;
      var off = k[i].getAttribute('data-s') !== s;
      if (k[i].hidden !== off) k[i].hidden = off;
    }
    d.state = s;
    var on = s === 'under' || s === 'over';
    wrap.style.setProperty('--fgo-ab-on', on ? '1' : '0');
    if (on) wrap.style.setProperty('--fgo-ab-pct', pct + '%');
    return true;
  }

  /* replace the text, keep the meter. The text span is a new node (no previous position, so no layout
     shift from it). The meter stays the same element so its fill slides to the new width instead of
     jumping; it and the arrow can move sideways by the width difference of two amounts ("$38.01" ->
     "$26.02"), a few px on a 64 x 6 px box, which is negligible layout shift. 28 Sep 2026: rebuilding the
     whole button here dropped the meter the first time the cart changed without a reload. */
  function underText(msg) {
    var u = el('under');
    if (!u || text(u) === msg) return;
    var span = document.createElement('span');
    span.className = 'fgo-ab__t';
    span.textContent = msg;
    var old = u.querySelector('.fgo-ab__t');
    if (old) { u.replaceChild(span, old); return; }
    u.insertBefore(span, u.firstChild);
  }

  var said = d.state === 'under' ? text(el('under')) : d.state === 'over' ? text(el('over')) : '';
  var liveT = 0;
  function announce(msg) {
    if (!live || !msg || msg === said) { said = msg || said; return; }
    said = msg;
    live.textContent = msg;
    clearTimeout(liveT);
    liveT = setTimeout(function () { live.textContent = ''; }, 5000);
  }

  function apply(c) {
    if (!c || typeof c.item_count !== 'number') return;
    var s = d.state;
    if (s === 'promo' || s === 'pdp') return;            /* higher in the order than the cart: they hold */
    var n = c.item_count, t = +c.total_price || 0, next, pct = 0, msg = '';
    if (n > 0 && el('under') && thr > 0) {
      pct = Math.min(100, Math.round(t / thr * 1000) / 10);
      if (t >= thr) {
        next = 'over';
        msg = text(el('over'));
      } else {
        next = 'under';
        msg = (d.under || '').replace('[amount]', money(thr - t));
        underText(msg);
      }
    } else if (n > 0) {
      next = 'empty';                                     /* a cart rules out "new visitor" */
    } else {
      next = s === 'new' ? 'new' : 'empty';
    }
    set(next, pct);
    if (msg) announce(msg); else said = '';
  }

  /* ---- cart reads: trailing 150ms, one in flight ---- */
  var nativeFetch = window.fetch;
  var timer = 0, busy = false, again = false;
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 150); }
  function refresh() {
    if (!nativeFetch) return;
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch.call(window, root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(apply)
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; schedule(); } });
  }
  function isWrite(method, url) { return /^post$/i.test(method || '') && WRITE.test(String(url || '')); }

  if (nativeFetch) {
    window.fetch = function (input, init) {
      var p = nativeFetch.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || String(input);
        var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
        if (isWrite(method, url)) p.then(schedule, schedule);
      } catch (e) {}
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var XP = window.XMLHttpRequest.prototype, xOpen = XP.open, xSend = XP.send;
    XP.open = function (method, url) {
      try { this.__fgoAbCart = isWrite(method, url); } catch (e) {}
      return xOpen.apply(this, arguments);
    };
    XP.send = function () {
      if (this.__fgoAbCart) { try { this.addEventListener('loadend', schedule); } catch (e) {} }
      return xSend.apply(this, arguments);
    };
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

  /* ---- taps ---- */
  function shown(node) { return !!(node && node.getClientRects().length); }
  function toSubscribe() {
    var picks = document.querySelectorAll('.pdpDelivCard--sub .pdpDelivInput, label.opt.sub input[value="sub"], .productFormSellingOptionHeaderInput[value="sub"], input[type="radio"][value="sub"]');
    var inp = null, card = null;
    for (var i = 0; i < picks.length; i++) {
      var c = picks[i].closest('.pdpDelivCard, label.opt, label, .productFormSelling') || picks[i];
      if (shown(c)) { inp = picks[i]; card = c; break; }
    }
    if (!card) card = document.querySelector('form[action*="/cart/add"]');   /* no Subscribe option: land on the buy box */
    if (!card) return;
    if (inp && !inp.checked) inp.click();                 /* a real click: the buy box repaints its own price */
    var promo = document.querySelector('[id*="theme-announcement"]');
    var head = document.querySelector('[id*="theme-header"]');
    var off = (promo ? promo.getBoundingClientRect().height : 0) + (head ? head.getBoundingClientRect().height : 0) + 16;
    var y = Math.max(0, card.getBoundingClientRect().top + (window.pageYOffset || 0) - off);
    var instant = reduce && reduce.matches;
    try { window.scrollTo({ top: y, behavior: instant ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
    card.classList.remove('fgo-ab-pulse');
    void card.offsetWidth;                                /* restart the animation on a second tap */
    card.classList.add('fgo-ab-pulse');
    clearTimeout(card.__fgoAbT);
    card.__fgoAbT = setTimeout(function () { card.classList.remove('fgo-ab-pulse'); }, 3400);
    if (inp) { try { inp.focus({ preventScroll: true }); } catch (e) {} }
  }

  a.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-fgo-ab-go]') : null;
    if (!t || !a.contains(t)) return;
    var go = t.getAttribute('data-fgo-ab-go');
    if (go === 'cart') {
      e.preventDefault();
      var btn = document.getElementById('headerRightIconsCart') || document.querySelector('.openCart');
      if (btn) btn.click(); else window.location.href = root + 'cart';
    } else if (go === 'sub') {
      e.preventDefault();
      toSubscribe();
    }
  });
})();
